import * as t from 'io-ts';
import { BasePostRequest } from './core/basePostRequest';
import { Authentication } from './core/baseRequest';

export class RequestLoyaltySchemeAccountRequest extends BasePostRequest<undefined> {
    constructor(
        public firstName: string,
        public surname: string,
        public email: string,
        public emailAddress: string,
        public telephone: string,
        public countryOfResidence: string,
        public stateOfResidence: string) {
        super('users/request-loyalty-scheme-account',
            {}, {
                firstName,
                lastName: surname,
                email,
                emailAddress,
                telephoneNumber: telephone,
                countryOfResidence,
                stateOfResidence
            }, t.undefined, Authentication.None);
    }
}
